import { ROLE } from '../../../modules/auth'

export type ClientRiskLevel = 'alarm' | 'look' | 'observe'

export interface ClientRiskPattern {
  code: string
  points: number
  triggered: boolean
  subject: string
}

export interface ClientRisk {
  score: number
  level: ClientRiskLevel
  summary: string
  patterns: ClientRiskPattern[]
}

export interface ClientSnapshotProfile {
  depositsCompleted: number
  depositsFailed: number
  receiptsForged: number
  lastForgedAt: string | null
  disputesOpened: number
  disputesLost: number
  payoutsCompleted: number
  payoutsFailed: number
  accounts: number
  merchants: number
  requisites: number
  sharedRequisiteClients: number
  browsers: number
  devices: number
  lookalikeClients: number
  deviceAccounts: number
  blockedLinks: number
  usualSenderBank: string | null
  usualPaymentMethod: string | null
  medianSecondsToPay: number | null
  firstSeenAt: string | null
  lastSeenAt: string | null
  profileRefreshedAt: string | null
}

export interface ClientSnapshot {
  profile: ClientSnapshotProfile
  risk: ClientRisk
}

export interface ClientSnapshotResponseData {
  client: ClientSnapshot | null
}

/** Те же роли, что видят список мэтчинг-депозитов; список совпадает с бэкендом. */
export const CLIENT_SNAPSHOT_ROLES: ROLE[] = [
  ROLE.ROLE_MANAGER,
  ROLE.ROLE_MATCHING_OPERATOR,
  ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
  ROLE.ROLE_MERCHANT_MANAGER,
]

/** Шкала балла на карточке и пороги уровней — те же, что в расчёте на бэкенде. */
export const SCORE_SCALE = { min: -3, max: 8, lookFrom: 3, alarmFrom: 4 }

export const PATTERN_LABELS: Record<string, string> = {
  forged_receipt: 'Поддельный чек',
  rejected_dispute: 'Проигранный диспут',
  lookalike: 'Похож на другого плательщика',
  fast_payment: 'Оплата быстрее обычного',
  slow_payment: 'Оплата медленнее обычного',
  new_payer: 'Новый плательщик',
  shared_device: 'Общее устройство',
  reliable: 'Надёжный',
  steady: 'Стабильный',
}

export const LEVEL_TITLES: Record<ClientRiskLevel, string> = {
  alarm: 'Тревога',
  look: 'Присмотреться',
  observe: 'Наблюдение',
}
